
import { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface LiveStreamContextType {
  youtubeUrl: string;
  setYoutubeUrl: (url: string) => void;
}

const LiveStreamContext = createContext<LiveStreamContextType>({
  youtubeUrl: '',
  setYoutubeUrl: () => {}
});

export const LiveStreamProvider = ({ children }: { children: ReactNode }) => {
  const [youtubeUrl, setYoutubeUrl] = useState<string>(() => {
    if (typeof window !== 'undefined') {
      const savedUrl = localStorage.getItem('youtubeStreamUrl');
      return savedUrl || '';
    }
    return '';
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (youtubeUrl) {
        localStorage.setItem('youtubeStreamUrl', youtubeUrl);
      } else {
        localStorage.removeItem('youtubeStreamUrl');
      }
    }
  }, [youtubeUrl]);

  // تهيئة القيمة الافتراضية للبث المباشر عند بدء التطبيق
  useEffect(() => {
    if (typeof window !== 'undefined' && !youtubeUrl) {
      const savedUrl = localStorage.getItem('youtubeStreamUrl');
      if (savedUrl) {
        setYoutubeUrl(savedUrl);
      }
    }
  }, []);

  const value = {
    youtubeUrl,
    setYoutubeUrl
  };

  return (
    <LiveStreamContext.Provider value={value}>
      {children}
    </LiveStreamContext.Provider>
  );
};

export const useLiveStream = () => {
  const context = useContext(LiveStreamContext);
  if (!context) {
    throw new Error('useLiveStream must be used within a LiveStreamProvider');
  }
  return context;
};
